'use client';

export { MDXRemote } from 'next-mdx-remote';
